import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "sonner";
import { Search } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { LR_STATUSES, lrSlug } from "../lib/format";
import { GRNCard } from "../components/grn/GRNCard";
import { ShortageSummary } from "../components/grn/ShortageSummary";
import { ExportButton } from "../components/ExportButton";

export default function GRNRegister() {
  const location = useLocation();
  const [q, setQ] = useState("");
  const [lr, setLr] = useState("All");
  const [list, setList] = useState(null);
  const [open, setOpen] = useState(location.state?.open || null);
  const [view, setView] = useState("list");

  const load = useCallback(() => {
    api.get("/grns", { params: { q, lr_status: lr } }).then((r) => setList(r.data)).catch((e) => toast.error(errMsg(e)));
  }, [q, lr]);

  useEffect(() => {
    const t = setTimeout(load, 250);
    return () => clearTimeout(t);
  }, [load]);

  return (
    <div className="space-y-4" data-testid="grn-register-page">
      <div className="grid grid-cols-2 gap-2"><ExportButton name="grns" label="GRN Excel" /><ExportButton name="returns" label="Returns Excel" /></div>
      <div>
        <p className="mono-label text-brand">Goods receipt &amp; LR tracking</p>
        <h1 className="font-heading text-2xl font-bold tracking-tight sm:text-3xl">GRN Register</h1>
        <p className="mt-1 text-sm text-muted-foreground">Raise a GRN from an Accepted PO in the PO Register.</p>
      </div>
      <div className="grid grid-cols-2 gap-1 rounded-xl border bg-card p-1">
        {[["list", "GRNs"], ["shortage", "Short & excess"]].map(([k, label]) => (
          <button key={k} onClick={() => setView(k)} data-testid={`grn-view-${k}`}
            className={`min-h-[44px] rounded-lg text-sm font-semibold transition-colors ${view === k ? "bg-primary text-primary-foreground" : "text-muted-foreground"}`}>{label}</button>
        ))}
      </div>
      {view === "shortage" ? <ShortageSummary /> : <>
      <div className="relative">
        <Search size={18} className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <input className="field !pl-10" placeholder="Search GRN, PO, vendor, LR or invoice" value={q} onChange={(e) => setQ(e.target.value)}
          data-testid="grn-search-input" />
      </div>
      <div className="seg">
        {["All", ...LR_STATUSES].map((x) => (
          <button key={x} data-active={lr === x} onClick={() => setLr(x)} data-testid={`grn-filter-${lrSlug(x)}`}>{x}</button>
        ))}
      </div>
      {!list ? (
        <p className="text-muted-foreground">Loading…</p>
      ) : list.length === 0 ? (
        <p className="panel p-6 text-center text-muted-foreground" data-testid="grn-empty">No GRNs found.</p>
      ) : (
        <div className="space-y-3" data-testid="grn-list">
          {list.map((g) => <GRNCard key={g.id} grn={g} open={open === g.id} onToggle={() => setOpen(open === g.id ? null : g.id)} onChanged={load} />)}
        </div>
      )}
      </>}
    </div>
  );
}
